export const setCustomShippingTags = {
  SET_CUSTOM_SHIPPING_TAGS(state, payload) {
    state.customShippingTags = payload;
  }
};
